module.exports = __webpack_public_path__ + "static/media/5.852d8c92.jpg";